/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "ap-northeast-1",
    "aws_content_delivery_bucket": "memopp-20250705172415-hostingbucket-dev",
    "aws_content_delivery_bucket_region": "ap-northeast-1",
    "aws_content_delivery_url": "https://dlwn432i8irgw.cloudfront.net",
    "aws_cloud_logic_custom": [
        {
            "name": "scheduleAPI",
            "endpoint": "https://tl2xvxejij.execute-api.ap-northeast-1.amazonaws.com/dev",
            "region": "ap-northeast-1"
        },
        {
            "name": "AdminQueries",
            "endpoint": "https://quuok0z31c.execute-api.ap-northeast-1.amazonaws.com/dev",
            "region": "ap-northeast-1"
        }
    ],
    "aws_appsync_graphqlEndpoint": "https://x3qrp35uhbentlwgotl7oazezi.appsync-api.ap-northeast-1.amazonaws.com/graphql",
    "aws_appsync_region": "ap-northeast-1",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_appsync_apiKey": "da2-njonyslagfbw7abjwynpryc2sa",
    "aws_dynamodb_all_tables_region": "ap-northeast-1",
    "aws_dynamodb_table_schemas": [
        {
            "tableName": "Schedules-dev",
            "region": "ap-northeast-1"
        }
    ],
    "aws_user_files_s3_bucket": "schedule-memo-cts2app29d8c-dev",
    "aws_user_files_s3_bucket_region": "ap-northeast-1",
    "aws_cognito_identity_pool_id": "ap-northeast-1:3beceaae-ab37-493a-88de-b6af31249d5b",
    "aws_cognito_region": "ap-northeast-1",
    "aws_user_pools_id": "ap-northeast-1_FEVFADVm0",
    "aws_user_pools_web_client_id": "5ijaeai5aviqt71dfeo2h6u6ac",
    "oauth": {},
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": [
            "REQUIRES_LOWERCASE",
            "REQUIRES_UPPERCASE",
            "REQUIRES_NUMBERS"
        ]
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ]
};


export default awsmobile;
